import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";
import { parseFaqs, faqAnswerToHtml, type Faq } from "@/lib/faqs";
import homeMd from "@/content/faqs/home.md?raw";

const defaultFaqs = parseFaqs(homeMd);

interface FaqSectionProps {
  faqs?: Faq[];
  heading?: string;
  /** Override the heading classes (e.g. to match a page's unified heading scale). */
  headingClassName?: string;
}

const FaqSection = ({
  faqs = defaultFaqs,
  heading = "Everything you need to know to get started",
  headingClassName = "text-3xl sm:text-4xl font-bold text-foreground lg:text-[3.25rem] leading-tight lg:leading-[1.21] tracking-tight",
}: FaqSectionProps) => {
  return (
    <section className="py-16 sm:py-20 md:py-24 px-6 sm:px-[8%] md:px-[10%]">
      <div className="grid gap-8 md:gap-16 lg:grid-cols-[0.8fr_1.8fr] items-start">
        <Reveal variant="slide-right">
          <h2 className={headingClassName}>
            {heading}
          </h2>
        </Reveal>
        <div>
          <Accordion type="single" defaultValue="faq-0">
            {faqs.map((faq, i) => (
              <Reveal key={i} variant="fade-up" delay={i * 80}>
                <AccordionItem
                  value={`faq-${i}`}
                  className="border-b border-border/40 py-0"
                >
                  <AccordionTrigger
                    icon="plus-minus"
                    className="text-base font-medium text-foreground hover:no-underline py-5 gap-4 text-left flex-row-reverse justify-end"
                  >
                    <span className="flex-1 text-left">{faq.q}</span>
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-muted-foreground pb-5 pl-[42px] leading-relaxed [&_p]:mb-2 [&_.faq-links]:mt-3 [&_.faq-links]:flex [&_.faq-links]:flex-wrap [&_.faq-links]:gap-x-3 [&_.faq-links]:gap-y-1 [&_.faq-link]:text-primary [&_.faq-link]:font-medium [&_.faq-link]:underline-offset-2 [&_.faq-link]:hover:underline">
                    <div dangerouslySetInnerHTML={{ __html: faqAnswerToHtml(faq.a) }} />
                  </AccordionContent>
                </AccordionItem>
              </Reveal>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
